import { bleskHeader } from '../../../default/src/scripts/modules/blesk-header';

bleskHeader();

/**
 * Modul loadMore inituje a nastavuje komponentu LoadMore, ktera zajistuje asynchronni nacteni obsahu
 *
 * Dynamicky import modulu, pokud existuje element, na ktery se ma aplikovat
 */
const dynamicLoadMore = async () => {
    /** @type {NodeListOf<HTMLElement>} */
    const loadMoreElements = document.querySelectorAll('[data-load-more]');

    if (loadMoreElements.length) {
        const { loadMore } = await import(
            /* webpackChunkName: 'chunk-load-more' */
            './modules/load-more'
        );

        loadMore(loadMoreElements);
    }
};

/**
 * Modul ipadChangeViewport zajistuje na iPadu upravu meta tagu viewport a pridani provizornich CSS
 *
 * Dynamicky import modulu, pokud je detekován iPad
 */
const dynamicIpadChangeViewport = async () => {
    if (document.documentElement.clientWidth <= 1024 && navigator.userAgent.match(/iPad/i)) {
        const { ipadChangeViewport } = await import('./modules/ipad-change-viewport');

        ipadChangeViewport();
    }
};

/**
 *  Google One click Login Porta
 */
export const dynamicPortaInit = async () => {
    const isPortaInitEnabled =
        new URLSearchParams(window.location.search).get('PortaInit') === 'true';
    if (!isPortaInitEnabled) return;

    const userNotLogged = document.querySelector('[data-user-not-logged]'); // Kontrolujeme, jestli uzivatel uz neni prihlaseny.
    const isDesktopDevice = window.innerWidth > 1080;

    if (userNotLogged && isDesktopDevice) {
        const { PortaInit } = await import(
            /* webpackChunkName: 'portaInit' */
            './modules/porta/PortaInit'
        );

        PortaInit();
    }
};

/** Spusteni dynamickych importu */
const loadDynamicImports = () => {
    dynamicLoadMore();
    dynamicIpadChangeViewport();
    dynamicPortaInit();
};

loadDynamicImports();
